module.exports = __webpack_public_path__ + "static/mazowsze_serce-f47245a967210e9c6e8d742a794fdaa3.png";